import React from 'react';
import { useTranslation } from 'react-i18next';
import { useBranding } from '../context/BrandingContext';

/**
 * Academy logo slot — shows cached/custom logo or a neutral placeholder
 * while branding loads (never flashes the generic deploy-time logo).
 */
export default function BrandingLogo({ className = '', boxClassName = '' }) {
    const { t } = useTranslation();
    const { logoUrl, appName, ready, hydrated } = useBranding();

    if (logoUrl) {
        return (
            <img
                src={logoUrl}
                alt={appName || t('common.academyLogo', { defaultValue: 'Academy logo' })}
                className={className}
            />
        );
    }

    if (!ready && !hydrated) {
        return <div className={`bg-slate-200/80 animate-pulse ${boxClassName || className}`} aria-hidden="true" />;
    }

    return null;
}
